import { makeWordPressAjaxRequest } from "@/lib/wordpress/ajax";
import { PropertiesDataV } from "@/types/tree";
import { pipe } from "fp-ts/lib/function";
import { fold } from "fp-ts/lib/Either";
import { _Error, logErrorsToUiStore } from "@/lib/wordpress/data";
import { globalStore } from "@/store/store-accessor";
import * as t from "io-ts";
import { fpJsonStringify } from "@/util/fp-json-stringify";
import { breakdanceUndo } from "@/lib/undo/undo";

export async function fetchGlobalSettings(): Promise<boolean> {
  const maybeGlobalSettingsData = await makeWordPressAjaxRequest({
    action: "breakdance_load_global_settings",
    decoder: PropertiesDataV
  });
  return pipe(
    maybeGlobalSettingsData,
    fold(
      errors => {
        logErrorsToUiStore(
          errors.map(err => {
            return {
              ...err,
              customNotificationToShow: err.customNotificationToShow
                ? err.customNotificationToShow.type === "INTERNAL_SERVER_ERROR"
                  ? { ...err.customNotificationToShow, keepOpen: true }
                  : err.customNotificationToShow
                : undefined
            };
          })
        );
        return false;
      },
      loadedData => {
        breakdanceUndo.ignore(() => {
          globalStore.setGlobalSettings(loadedData.globalSettings);
          globalStore.markCurrentGlobalSettingsAsUntouched();
        });
        return true;
      }
    )
  );
}

export async function saveGlobalSettingsToWordPress(): Promise<boolean> {
  return pipe(
    await makeWordPressAjaxRequest({
      friendlyName: "Saving global settings to WordPress",
      action: "breakdance_save_global_settings",
      dataToPost: {
        globalSettings: fpJsonStringify(globalStore.globalSettings)
      },
      decoder: t.unknown
    }),
    fold(
      (errors: _Error[]) => {
        logErrorsToUiStore(errors);
        return false;
      },
      () => {
        breakdanceUndo.ignore(() =>
          globalStore.markCurrentGlobalSettingsAsUntouched()
        );
        return true;
      }
    )
  );
}
